import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { Spacer } from 'design-system';
import { IconBoldCalendar } from 'design-system/icons';
import ItemBadgeWrapper from './ItemBadgeWrapper';
const DateItemBadge = ({ filter, handleClose, scrollY, isActiveKeyboard, scrollToItem, onPress }) => (<ItemBadgeWrapper scrollY={scrollY} handlePress={onPress} onCancel={handleClose} scrollToItem={scrollToItem} isActiveKeyboard={isActiveKeyboard}>
    <IconBoldCalendar gradientKey="lightPurple" width={16} height={16}/>
    <Spacer w={4}/>
    <View style={styles.container}>
      <Text Text-14>{filter.badgeText}</Text>
    </View>
  </ItemBadgeWrapper>);
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
export default DateItemBadge;
